[
  {
    "id": "GET-E7-L205-001",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Welk deel is 12 van de 60?",
    "options": [
      "$\\frac{1}{5}$",
      "$\\frac{1}{4}$",
      "$\\frac{1}{6}$",
      "$\\frac{1}{3}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vereenvoudigen",
    "familyId": "GET-BREUK-VEREENVOUDIGEN",
    "explanation": "12 van de 60 is $\\frac{12}{60}$. Je kunt beide delen door 12. Dan krijg je $\\frac{1}{5}$. Of: 5 $\\times$ 12 = 60.",
    "distractorExplanations": {
      "1": "4 $\\times$ 12 = 48, niet 60.",
      "2": "6 $\\times$ 12 = 72, niet 60.",
      "3": "3 $\\times$ 12 = 36, niet 60."
    }
  },
  {
    "id": "GET-E7-L205-002",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Hoeveel procent is $\\frac{3}{4}$?",
    "options": [
      "75%",
      "25%",
      "50%",
      "34%"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "Een kwart ($\\frac{1}{4}$) is 25%. Drie kwart is 3 $\\times$ 25% = 75%.",
    "distractorExplanations": {
      "1": "Dat is één kwart.",
      "2": "Dat is een half.",
      "3": "Je hebt de cijfers 3 en 4 gewoon achter elkaar gezet."
    }
  },
  {
    "id": "GET-E7-L205-003",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Reken uit: 0,6 : 0,2 =",
    "options": [
      "3",
      "0,3",
      "30",
      "1,2"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen",
    "familyId": "GET-DELEN-KOMMA",
    "explanation": "Hoe vaak past 0,2 in 0,6? Dat is 3 keer. Denk aan geld: hoe vaak past 20 cent in 60 cent?",
    "distractorExplanations": {
      "1": "Je hebt de komma laten staan. 0,6 : 0,2 is een heel getal.",
      "2": "Dat is veel te veel. Je hebt waarschijnlijk met 10 vermenigvuldigd.",
      "3": "Je hebt vermenigvuldigd in plaats van gedeeld."
    }
  },
  {
    "id": "GET-E7-L205-004",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Op een kaart is de schaal 1 : 100.000. Hoeveel km is 5 cm op de kaart?",
    "options": [
      "5 km",
      "50 km",
      "0,5 km",
      "500 km"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-SCHAAL",
    "explanation": "1 cm = 100.000 cm = 1.000 meter = 1 km. Dus 5 cm = 5 km.",
    "distractorExplanations": {
      "1": "Je hebt een nul te veel. 1 cm = 1 km, niet 10 km.",
      "2": "Je hebt een nul te weinig. 1 cm = 1 km, niet 0,1 km.",
      "3": "Je hebt twee nullen te veel. Controleer de omrekening van cm naar km."
    }
  },
  {
    "id": "GET-E7-L205-005",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Wat is het gemiddelde van 6, 8 en 10?",
    "options": [
      "8",
      "7",
      "9",
      "24"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "gemiddelde",
    "familyId": "GET-GEMIDDELDE",
    "explanation": "Tel op: 6 + 8 + 10 = 24. Deel door het aantal getallen: 24 : 3 = 8.",
    "distractorExplanations": {
      "1": "Te laag. Het gemiddelde is (6 + 8 + 10) : 3 = 8.",
      "2": "Te hoog. Het gemiddelde is (6 + 8 + 10) : 3 = 8.",
      "3": "Dit is de som van alle getallen. Je moet nog delen door 3."
    }
  },
  {
    "id": "GET-E7-L205-006",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Een bedrag stijgt van € 320,- naar € 368,-. Met hoeveel procent is het bedrag gestegen?",
    "options": [
      "15%",
      "10%",
      "12%",
      "18%"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-STIJGING",
    "explanation": "De stijging is 368 - 320 = 48 euro. Om het percentage te weten deel je de stijging door het oude bedrag: 48 : 320 = 0,15. Dat is 15%.",
    "distractorExplanations": {
      "1": "10% van 320 is 32, maar de stijging is 48 euro. Dat is meer dan 10%.",
      "2": "12% van 320 is 38,40. Maar de stijging is 48 euro, dus het percentage is hoger.",
      "3": "18% van 320 is 57,60. Dat is te veel, de stijging is maar 48 euro."
    }
  },
  {
    "id": "GET-E7-L205-007",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Na een korting van 8% kost een fiets nog maar € 138,-. Wat was de oorspronkelijke prijs?",
    "options": [
      "€ 150,-",
      "€ 146,-",
      "€ 160,-",
      "€ 170,-"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-TERUGREKENEN",
    "explanation": "De korting is 8%, dus je betaalt nog 100% - 8% = 92%. € 138 is dus 92% van de oude prijs. De oude prijs was 138 : 0,92 = € 150,-.",
    "distractorExplanations": {
      "1": "Je telde de 8% simpelweg bij de prijs op (138 + 8% van 138 ≈ 149), maar bij korting moet je 'terugrekenen' naar het oorspronkelijke bedrag.",
      "2": "Je rekende waarschijnlijk met 10% korting. Maar 10% korting op 160 geeft 144, niet 138.",
      "3": "Je maakte een fout bij de deling. 8% van 170 is 13,60, dan zou de prijs 156,40 zijn."
    }
  },
  {
    "id": "GET-E7-L205-008",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Op een bedrag van € 250,- komt 21% btw. Wat is de totale prijs inclusief btw?",
    "options": [
      "€ 302,50",
      "€ 275,-",
      "€ 300,-",
      "€ 312,50"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BTW",
    "explanation": "10% van 250 is 25. Dus 20% is 50. 1% van 250 is 2,50. Dus 21% is 50 + 2,50 = 52,50. Totaal: 250 + 52,50 = € 302,50.",
    "distractorExplanations": {
      "1": "Je rekende waarschijnlijk met slechts 10% btw (250 + 25 = 275).",
      "2": "Je rondde de 21% af naar 20% (250 + 50 = 300). Maar 21% is iets meer.",
      "3": "Je maakte een rekenfout bij het optellen van de btw-bedragen."
    }
  },
  {
    "id": "GET-E7-L205-009",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Wat is het gemiddelde van 12, 15, 18 en 23?",
    "options": [
      "17",
      "16",
      "18",
      "15"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "gemiddelde",
    "familyId": "GET-GEMIDDELDE",
    "explanation": "Tel op: 12 + 15 + 18 + 23 = 68. Deel door 4: 68 : 4 = 17.",
    "distractorExplanations": {
      "1": "Je maakte een optelfout. De som is 68, niet 64.",
      "2": "Je deelde door 3 in plaats van door 4. Er zijn 4 getallen.",
      "3": "Je vergat het laatste getal (23) mee te tellen."
    }
  },
  {
    "id": "GET-E7-L205-010",
    "module": "Getalbegrip",
    "difficulty": 205,
    "question": "Reken uit: 4,8 : 0,4 =",
    "options": [
      "12",
      "1,2",
      "120",
      "0,12"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen",
    "familyId": "GET-DELEN-KOMMA",
    "explanation": "Hoe vaak past 0,4 in 4,8? Vermenigvuldig beide met 10: 48 : 4 = 12.",
    "distractorExplanations": {
      "1": "Je hebt de komma verkeerd geplaatst. Vermenigvuldig beide met 10 om de komma weg te werken.",
      "2": "Je hebt een nul te veel. 48 : 4 = 12, niet 120.",
      "3": "Je hebt twee keer de komma verschoven in de verkeerde richting."
    }
  }
]